<template>
  <master-main
    :addProperties="{
      eventType: 1,
      routeToCreate: getModuleRoute,
    }"
    :exportProperties="{
      pdf: {
        filename: `${$t(
          'production.category_rejection_cause'
        )}_${dateToday}.pdf`,
        route: `${getModuleRoute}/pdf`,
      },
      xls: {
        filename: `${$t(
          'production.category_rejection_cause'
        )}_${dateToday}.xlsx`,
        route: `${getModuleRoute}/excel`,
      },
    }"
    :dataBadges="[
      {
        columnLabel: $t('common_words.crops'),
        data: 'crops',
        property: 'name',
        minWidth: 120,
      },
      {
        columnLabel: $t('common_words.associated_companies2'),
        data: 'businesses',
        property: 'name',
        minWidth: 160,
      },
    ]"
    :route="getModuleRoute"
    :tableProperties="tableProperties"
    @refresh="refresh"
    :showSubcategories="true"
    @showHideLoading="showHideLoading"
    @showNotification="notifyVue"
    ref="masterMain"
  >
  </master-main>
</template>
<script>
import CausesRejectedCategoryTable from 'src/views/Pages/Dashboard/Rejected/CausesRejectionsCategories/causes-rejected-category-table.js';
import { getDateToday } from 'src/util/Util';
import i18n from 'src/i18n';
import MasterMain from 'src/components/Layouts/Masters/MasterMain.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMain from 'src/mixins/master/mixin-main';
import MixinPermissions from 'src/util/mixinPermissions';

export default {
  components: { MasterMain },
  data() {
    return {
      tableProperties: {},
      showProperties: { size: '65%' },
    };
  },
  mixins: [MixinAlert, MixinLoading, MixinMain, MixinPermissions],
  computed: {
    getModuleRoute() {
      return 'rejecteds/categories';
    },
    dateToday() {
      return getDateToday();
    },
    buildTableProperties() {
      return {
        tableColumns: [...CausesRejectedCategoryTable().tableColumns],
        model: 'category',
        widthColumnStatus: 120,
        widthOperations: 110,
        effectTags: 'dark',
        addColumns: [
          {
            data: 'crops',
            label: i18n.t('common_words.crops'),
            field: 'name',
          },
        ],
      };
    },
  },
};
</script>
